import { combineReducers } from "redux";

import { reducer as rewards } from "../modules/rewards/reducer";
import { reducer as preferences } from "../modules/preferences/reducer";
import { wishlistManagementModalReducer } from "halifax";
import { wishlistsApi, spreedlyCredentialsApi } from "@capone/common";

export const rootReducer = combineReducers({
  rewards,
  preferences,
  [wishlistsApi.reducerPath]: wishlistsApi.reducer,
  [spreedlyCredentialsApi.reducerPath]: spreedlyCredentialsApi.reducer,
  wishlistManagementModal: wishlistManagementModalReducer,
});
